/*
  Base file for stub.
  This is where all the actual stub code will go.
*/

// REQUIRED IMPORTS
const $ = require('jquery');
import _ from "underscore";
import run from '../../utilities/run';
import render from "../../utilities/render";
import {isPresent} from "../../utilities/general";
const modalHtml = require("../../sharedHtml/modal.html");
import ConfigPanel from "../ConfigPanel/ConfigPanel";

import FacilitiesTab from './FacilitiesTab';
import ProductsTab from './ProductsTab';
import ShippingTab from './ShippingTab';
import ReviewTab from './ReviewTab';

// Product Modal
import {orderData} from "../../stores/orderDataExample";
const productModalFooterLeft = require('../../utilities/productsModalUtilities/html/modalOrderFooterLeft.html');
const productModalFooterBtns =  require('../../utilities/productsModalUtilities/html/modalOrderFooterBtns.html');
const productModalOrderBody = require("../../utilities/productsModalUtilities/html/modalOrderBody.html");
import {handleTotalChecked, modalRenderCheckbox, modalRenderPillUnits} from '../../utilities/productsModalUtilities';

const targetSelector = "#order-transfer-wizard";
// Additional Imports...
 // For quick dev prototyping
run(targetSelector, ()=>{
  const el = $(targetSelector);
  TransferOrderWizard(el);
  setupEditChecker(el);
});

function setupEditChecker(el){
  EditChecker.bindNavigation();
  EditChecker.bindChangeListener(targetSelector);
  EditChecker.bindChangeListener("span.select2");
  $("#order-cancel-btn").data("edit-checker-redirect", el.data("cancel-redirect-url")); // cancel url set from jsp
  EditChecker.bindCancelButton("#order-cancel-btn");
}

export default function TransferOrderWizard(el){
  // START: REQUIRED TO LOAD STUB
  const validator = el.validate({
    errorPlacement: function(error, element) {
      let appendClosest = $(element).data('error-placement-append-closest');
      if (appendClosest) {
        $(element).closest(appendClosest).append(error);
      } else {
        error.insertAfter(element);
      }
    },
    // Place all your validation rules here!!!
    rules: {
      "orderFulfillmentCenter": {
        validFacility: ".destination-facility"
      },
      "destinationFulfillmentCenter": {
        validFacility: ".origin-facility"
      }
    }
  });

  validator.settings.ignore = ":disabled,:hidden";

  $.validator.addMethod(
    "validFacility",
    function(value, element, params) {
      if(value === $(params).val()) {
        return false;
      } else {
        return true;
      }
    },
    "Please choose another facility."
  );

  const wizardHtml = $(render(
    require("./html/transferOrderWizard.html"),{
      facilityTab: require("./html/facilityTab.html"),
      productsTab: require("./html/productsTab.html"),
      shippingTab: require("./html/shippingTab.html"),
      reviewTab: require("./html/reviewTab.html")
    },
  ));

  el.html(wizardHtml);

  const quickWizard = new QuickWizard(el, {
    tabletWidthNavStep: 1048,
    mobileWidthNavStep: 886,

    customRules: {
      "#products-empty-table-validator": {
        errorMessageSelector: ".products-tab-products-table-error-message",
        isValid: function(){
          return productsTab.isValid();
        }
      }
    },
    shouldNavigateToForm: ({targetForm, direction, currentForm, done})=>{
     // Any time we go traverse backwards, just let us
      if(direction === "BACKWARDS"){
        return true;
      }

      areInputsValid(true, done);

      function areInputsValid(shouldContinue, cb) {
        let allPrevInputs = quickWizard.allPreviousFieldsUpToTargetForm(targetForm);
        let notValid = !quickWizard.areInputsValid(allPrevInputs, {displayErrors: true});
        if(notValid || !shouldContinue){
          if(notValid){
            quickWizard.goToFirstIncompleteForm();
          }
          cb(false);
        } else {
          cb(true);
        }
      }

      return done;
    },
    didNavigateToForm: ({currentForm})=>{
      if(currentForm.filter('.products-tab').length){
        productsTab.didNavigateToForm();
        //productsTab.setProductLookupAndModal(productsTab.productItems.regularItems , productsTab.productNameArr.regularItems);
      } else if(currentForm.filter('.review-tab').length) {
        reviewTab.didNavigateToForm();
      }
    }
  });

  quickWizard.init();

  $(document).on('click', "[data-target-form]", function(){
    const form = el.find($(this).data("target-form"));
    quickWizard.gotToForm(form);
  });

  // Modal Options/Creation
  const modalOpts = {backdrop:'static', show: false};

  //Add products Modal
  const addProductsModal = $(render(
    modalHtml,
    {
      autoHideTop: true,
      topCloseBtn: true,
      title:'Product Selection',
      footerLeft: productModalFooterLeft,
      footerBtns: productModalFooterBtns,
      body: render(
        productModalOrderBody,
        {
          originFacilityAlertBlock: true,
          availableQuantityColumn: true,
          typeColumn: true
        }
      ),
      modalDialogClass:'q-modal-dialog-800'
    }
  ));
  addProductsModal.find('.product-search-modal-input').on( 'keyup', function () {
    modalOrderTable.api().search( this.value ).draw();
    handleTotalChecked(addProductsModal, modalOrderTable, modalCheckboxSelector);
  });
  // DataTable
  const defaultDataTableOptions = {
    "dom": "t",
    "paging": false,
    "ordering": false,
    "info": false,
  }
  // NOTE: THIS DATA TABLE SHOULD BE INSTANTIATED VIA AJAX AS CURRENTLY DONE IN pages/orders/productsTab.js
  const modalOrderTable = addProductsModal.find('.modal-order-table').dataTable({
    ...defaultDataTableOptions,
    data: orderData,
    "columnDefs": [
      //{ className: "", "targets": [ 1, 2, 3, 4 ] }
    ],
    columns: [
      {
        data: "itmId",
        className: "order-checkbox-wrapper",
        render: modalRenderCheckbox
      },
      {
        data: "itmSku",
        className: "order-modal-sku"
      },
      {
        data: "prdNameAndAttributes"
      },
      {
        data: "availUnit",
        className: "q-text-center order-modal-pills",
        render: modalRenderPillUnits
      },
      {
        data: "type",
        className: "q-text-center order-modal-type"
      }
    ]
  });
  const modalCheckboxSelector = ".order-modal-checkbox";
  //add-up how many Checkboxes are checked!
  $(document).on("change", modalCheckboxSelector, function() {
    handleTotalChecked(addProductsModal, modalOrderTable, modalCheckboxSelector);
  });

  // START: Date Picker (required)
  const date = new Date();
  date.setDate(date.getDate() + 1);
  $(".func-date-range-input").datepicker({
    startDate: date,
    todayBtn: false,
    keyboardNavigation: false,
    autoclose: true
  });
  // END: Date Picker (required)

  $(el).append(addProductsModal);

  addProductsModal.modal(modalOpts);

  // START: REAL CODE

  const facilitiesTab = new FacilitiesTab(quickWizard);
  facilitiesTab.init();

  const productsTab = new ProductsTab(quickWizard, addProductsModal);
  productsTab.init();

  const shippingTab = new ShippingTab(quickWizard);
  shippingTab.init();

  const reviewTab = new ReviewTab(quickWizard);
  reviewTab.init();

  // END: REAL CODE
};



// WEBPACK FOOTER //
// ./src/pages/transferOrder/transferOrderWizard.js